import { Overlay, type PopoverProps } from './Dropdown'

// ---------------------------------------------------------------------------
// Popover — presentational anchored panel (props in → UI out).
//
// The same overlay shell as Dropdown (shared engine in ./Dropdown), but for
// arbitrary panel content with NO menu/listbox semantics. Renders the panel
// through createPortal using Designsystemet's native manual-popover surface;
// `.popover` / `.popover-backdrop` remain layout hooks. Surface-agnostic: no data
// fetching, no privileged logic, no Norwegian strings.
// ---------------------------------------------------------------------------

export type { PopoverProps } from './Dropdown'

/**
 * Anchored popover: opens on trigger activation; closes on outside-click (a
 * transparent backdrop) and Escape. The trigger carries
 * `aria-haspopup="dialog"` + `aria-expanded`; focus moves into the panel on
 * open and returns to the trigger on close. Unlike {@link Dropdown}, a click
 * inside the panel does not close it — the caller owns the content's behavior.
 *
 * @example
 * <Popover trigger={<Button>{t('notifications')}</Button>}>
 *   <div className="popover__hd">
 *     <span className="popover__title">{t('inbox')}</span>
 *   </div>
 *   <div className="popover__list">…</div>
 * </Popover>
 */
export function Popover(props: PopoverProps) {
  return <Overlay {...props} menu={false} />
}
